export default __webpack_public_path__ + "static/media/verified-rounded.2190d8f5.svg";